<app-status-chip [tone]="tone">{{ label }}</app-status-chip>
